import Card from "@components/ui/Card/Card";
import './Badges.scss';

type BadgeType = {
    label: string,
    value: string,
};

type BadgesProps = {
    className?: string,
    items: Array<BadgeType>,
};

function Badges(props: BadgesProps) {

    return (
        <Card className={`badges-container ${props.className ?? ''}`}>
            {props.items.map((badge: BadgeType, index: number) => (
                <div key={index} className="badge">
                    <span className="badge-label">{badge.label}</span>
                    <span className="badge-value">{badge.value}</span>
                </div>
            ))}
        </Card>
    );
}

export default Badges;
